import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CategoryDetail from "./CategoryDetail";
import { calcLength } from "framer-motion";

interface LocationState {
  fileCount: number;
  batchGuid?: string;
  classificationName?: string;
}

const CategoryDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { category, batchGuid: urlBatchGuid } = useParams<{
    category: string;
    batchGuid: string;
  }>();

  const state = location.state as LocationState;
  const fileCount = state?.fileCount || 0;
  const batchGuid = urlBatchGuid || state?.batchGuid;
  const classificationName = state?.classificationName;

  const handleBack = () => {
    navigate(-1);
  };

  const handleExtractAll = () => {
    // Implement extract all logic here
  };

  if (!category) {
    navigate("/classification-hub");
    return null;
  }

  return (
    <CategoryDetail
      category={category}
      fileCount={fileCount}
      batchGuid={batchGuid}
      classificationName={classificationName}
      onBack={handleBack}
      onExtractAll={handleExtractAll}
    />
  );
};

export default CategoryDetailPage;
